/** @format */

import {TanStackTableData} from 'components/Table/core/types';

/**
 * Определит, по какой колонке сортировать сенсоры по умолчанию
 * Приоритет отдаётся колонке с самым большим значением
 * @param data
 */

const getDefaultSensorSortBy = (data: TanStackTableData[]): string => {
  const allRedValues = data.map(d => Number(d['red'])).filter(v => !isNaN(v));
  const redMax = Math.max(...allRedValues);
  const allYellowValues = data.map(d => Number(d['yellow'])).filter(v => !isNaN(v));
  const yellowMax = Math.max(...allYellowValues);
  const allGrayValues = data.map(d => Number(d['gray'])).filter(v => !isNaN(v));
  const grayMax = Math.max(...allGrayValues);

  const maxOfTheMax = Math.max(redMax, yellowMax, grayMax);

  if (maxOfTheMax === redMax) {
    return 'red';
  }

  if (maxOfTheMax === yellowMax) {
    return 'yellow';
  }

  if (maxOfTheMax === grayMax) {
    return 'gray';
  }

  return 'red';
};

export {getDefaultSensorSortBy};
